module.exports = __webpack_public_path__ + "static/img/10.e3a2385.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/10.jpg
// module id = B2pQ
// module chunks = 1